<template>
  <div
    class="yxtbiz-ojtaudit"
    v-loading="loadingAudit"
  >
    <div v-if="isError">
      <!-- 带教范围可能被删除，请联系项目负责人 -->
      <yxtf-empty
        size='medium'
        :empty-text="$t('pc_biz_o2o_range_delete_tip')"
      ></yxtf-empty>
    </div>
    <template v-else>
      <div class="yxtbiz-ojtaudit__title">
        {{ chooseType ? $t('pc_biz_o2o_lbl_te_choose_stu' /* 导师选学员 */) : $t('pc_biz_ojt_tit_student_choose_teacher' /* 学员选导师 */) }}
      </div>

      <div class="mt24">
        <div class="yxtbiz-ojtaudit__info-wrapper">
          <div
            v-for="info in auditLists"
            :key="info.name"
            class="w-50p yxtbiz-ojtaudit__info-line"
          >
            <span class="color-gray-7 d-in-block lh22">{{ info.name }}</span>

            <yxtf-tooltip
              open-filter
              placement="top"
            >
              <yxtbiz-user-name
                slot="content"
                :name="info.value"
              />
              <yxtbiz-user-name
                class="color-gray-10 d-in-block lh22 ellipsis w-max-70p nowrap"
                :name="info.value"
              />
            </yxtf-tooltip>
          </div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
import { getAuditFormInfo } from '../service';
import { getTaskType } from './utils';

export default {
  name: 'YxtbizOjtAudit',
  name_zh: '带教审核信息页',
  props: {
    formId: {
      type: String,
      required: true,
      desc: '表单id',
      setter: 'StringSetter'
    },

    pid: {
      type: String,
      desc: '项目id',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      loadingAudit: true,
      chooseType: 0,

      auditLists: [
        { name: `${this.$t('pc_biz_ojt_lbl_projectname' /* 项目名称 */)}：`, value: '' },
        { name: `${this.$t('pc_biz_o2o_lbl_teach_range' /* 带教范围 */)}：`, value: '' },
        { name: `${this.$t('pc_biz_ojt_lbl_student_name' /* 学员姓名 */)}：`, value: '' },
        { name: `${this.$t('pc_biz_ojt_lbl_teacher_name' /* 导师姓名 */)}：`, value: '' }
      ],
      isError: false
    };
  },

  created() {
    this.loadingAudit = true;
    getAuditFormInfo({ formId: this.formId, projectId: this.pid }).then(res => {
      const { chooseType, projectName, stuFullName, teFullName, scope } = res;

      // 判断scope是否有值，一般为null就是阶段为空
      if (scope) {
        this.chooseType = chooseType;

        this.updateAuditVal({ projectName, scopeName: this.returnRangeName(scope), stuFullName, teFullName });
      } else {
        this.isError = true;
      }
    }).finally(() => {
      this.loadingAudit = false;
    });
  },

  methods: {
    // ojtMode:0阶段制，1项目制，2任务制
    returnRangeName({ ojtMode, scopeName, orderIndex, scopeType, period }) {
      switch (~~ojtMode) {
        case 0:
          return period ? `${this.$t('pc_biz_ojt_lbl_phase' /* 阶段 */)}${orderIndex}-${scopeName}` : this.$t('pc_biz_o2o_lbl_nophase' /* 无阶段 */);
        case 1:
          return this.$t('pc_biz_o2o_lbl_wholeProject' /* 整体项目 */);
        case 2: {
          let str = '';
          if (period) {
            str += `${this.$t('pc_biz_ojt_lbl_phase' /* 阶段 */)}${orderIndex}-`;
          }

          str += `${getTaskType(scopeType)}-${scopeName}`;
          return str;
        }
      };
    },
    updateAuditVal({ projectName, scopeName, stuFullName, teFullName }) {
      const arr = [projectName, scopeName, stuFullName, teFullName];

      this.auditLists.forEach((item, index) => {
        item.value = arr[index] || '';
      });
    }
  }
};
</script>
